module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_19.d9dee2e6.jpg";